import { render, staticRenderFns } from "./JoinGame.vue?vue&type=template&id=5e8a451c&scoped=true"
import script from "./JoinGame.vue?vue&type=script&lang=js"
export * from "./JoinGame.vue?vue&type=script&lang=js"
import style0 from "./JoinGame.vue?vue&type=style&index=0&id=5e8a451c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8a451c",
  null
  
)

export default component.exports